export const MILLIS_IN_SECOND = 1000;
